import Control from './control';
import Doublebox from './doublebox';
import Singlebox from './singlebox';
import Opendesign from './opendesign';

import LaunchDarkly from '@module/launchdarkly';
import { EXPERIMENT_SPLASHPAGE_REDESIGN } from '@constant/experiments';

// To show splashpage variant appending `#ab_splashpage-redesign=doublebox` to the url
const variant = LaunchDarkly.getVariant(EXPERIMENT_SPLASHPAGE_REDESIGN);

const VariantToComponentMap = {
  doublebox: Doublebox,
  singlebox: Singlebox,
  opendesign: Opendesign,
};

export default VariantToComponentMap[variant] || Control;
